module.exports = __webpack_public_path__ + "img/1234567891.0c8f65e3.png";